/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';
import appConfig from 'app-config';
import _ from 'lodash';
import { FormModalPopover } from 'ml-components-platform-react';
import { withRouter } from 'react-router-dom';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useModal } from '@jutro/components';
import { MLPolicyChangeBtnComponent } from 'ml-capability-policychange-common-react';

import metadata from './MLAgentPolicyBillingPaymentDetailsComponent.metadata.json5';
import messages from './MLAgentPolicyBillingPaymentDetailsComponent.messages';
import styles from './MLAgentPolicyBillingPaymentDetailsComponent.module.scss';
import mlPaymentSchedulePopupMsgs from './MLPolicyBillingPaymentSchedulePopup/MLPolicyBillingPaymentSchedulePopup.messages';
import MLPolicyBillingPaymentSchedulePopup from './MLPolicyBillingPaymentSchedulePopup/MLPolicyBillingPaymentSchedulePopup';


import { Link } from '@jutro/router';


const MLAgentPolicyBillingPaymentDetailsComponent = (props) => {
    const modalApi = useModal();
    const { 
        history, 
        authUserData,
        policyNumber,
        accountNumber,
        productCode,
        billingSummary,
        termNumber,
        canceled,
        hasLimitedAccess,
        billingInValid,
        /* setBillingInValid, */
        convertLocalDateToDate,
        formatAmountString
    } = props;
    const { MLUserTypes, fixedBCJobURL } = appConfig;
    const translator = useTranslator();
    const isGscUser = authUserData && authUserData.userType === MLUserTypes.GCS_SERVICING;

    const [isPayInFull, setIsPayInFull] = useState(false);
    const [isResponsive, setIsResponsive] = useState(false);
    const [isCreditCard, setIsCreditCard] = useState(false);
    const [isMortgagee, setIsMortgagee] = useState(false);
    const [isPayrollDeduct, setIsPayrollDeduct] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [lastPaymentReceivedText, setLastPaymentReceivedText] = useState('');
    const [paymentMethodText, setPaymentMethodText] = useState('');
    const [nextAutoPaymentText, setNextAutoPaymentText] = useState('');
    const [paidThroughText, setPaidThroughText] = useState('');
    const [paymentScheduleText, setPaymentScheduleText] = useState('');
    const [paymentDueText, setPaymentDueText] = useState('');
    const [accountNumberText, setAccountNumberText] = useState('');
    const [payrollDeduct, setPayrollDeduct] = useState({});

    const getDateSuffix = (i) => {
        const j = i % 10;
        const k = i % 100;
        if (j === 1 && k !== 11) {
            return i.concat('st');
        }
        if (j === 2 && k !== 12) {
            return i.concat('nd');
        }
        if (j === 3 && k !== 13) {
            return i.concat('rd');
        }
        return i.concat('th');
    };

    const getFormattedDate = (date, format) => {
        const dateFormat = _.isUndefined(format) ? 'MM/DD/YYYY' : format;
        return _.isEmpty(date) ? '' : convertLocalDateToDate(date, dateFormat);
    };

    const getFormattedAmount = (amount) => {
        return _.isEmpty(amount) ? '' : formatAmountString(amount);
    };

    const getScheduledDays = () => {
        const day1 = getDateSuffix(billingSummary.deductionDate1_ML.day.toString());
        let text = day1;
        if (billingSummary.deductionDate2_ML) {
            const day2 = getDateSuffix(billingSummary.deductionDate2_ML.day.toString());
            text = translator(messages.day1AndDay2, {day1: day1, day2: day2});
        }
        return text;
    };

    const fillNextAutoPaymentText = () => {
        const nextAutoPaymentVal = translator(messages.dateAndAmount, {
            date: getFormattedDate(billingSummary.nextAutomaticPaymentDate_ML),
            amount: getFormattedAmount(billingSummary.nextAutomaticPaymentAmount_ML)
        });
        setNextAutoPaymentText(nextAutoPaymentVal);
    };

    const fillPaidThroughText = () => {
        const paidThroughVal = translator(messages.dateAndAmount, {
            date: getFormattedDate(billingSummary.paidThroughDate_ML),
            amount: getFormattedAmount(billingSummary.paidThroughAmount_ML)
        });
        setPaidThroughText(paidThroughVal);
    };

    const fillPaymentScheduleText = () => {
        const paymentScheduleVal = translator(messages.scheduleAndDays, {
            schedule: billingSummary.paymentSchedule_ML, 
            days: getScheduledDays()
        });
        setPaymentScheduleText(paymentScheduleVal);
    };

    const fillPaymentDueText = () => {
        const paymentDueVal = translator(messages.dateAndAmount, {
            date: getFormattedDate(billingSummary.paymentDueDate_ML),
            amount: getFormattedAmount(billingSummary.paymentDueAmount_ML)
        });
        setPaymentDueText(paymentDueVal);
    };

    const fillLastPaymentReceivedText = () => {
        const lastPaymentReceivedVal = translator(messages.dateAndAmount, {
            date: getFormattedDate(billingSummary.lastPaymentReceivedDate_ML),
            amount: getFormattedAmount(billingSummary.lastPaymentReceivedAmount_ML)
        });
        setLastPaymentReceivedText(lastPaymentReceivedVal);
    };

    const setCreditCardDetails = () => {
        setPaymentMethodText(billingSummary.paymentDisplayName_ML);
        if (billingSummary.paymentNickName_ML) {
            setPaymentMethodText(billingSummary.paymentNickName_ML);
        }
        fillNextAutoPaymentText();
        fillPaidThroughText();
        fillPaymentScheduleText();       
        setIsPayInFull(billingSummary.paymentSchedule_ML === 'Pay In Full (100% down)');
    };

    const setCheckingDetails = () => {
        setPaymentMethodText(translator(messages.checkingOrSavings));
        if (billingSummary.paymentNickName_ML) {
            setPaymentMethodText(billingSummary.paymentNickName_ML);
        }
        setAccountNumberText(translator(messages.endingInNumber, {number: billingSummary.accountNumberLast4_ML}));
        fillNextAutoPaymentText();
        fillPaidThroughText();
        fillPaymentScheduleText();  
        setIsPayInFull(billingSummary.paymentSchedule_ML === 'Pay In Full (100% down)');
    };

    const setPayrollDeductFields = () => {
        setPaymentMethodText(translator(messages.payrollDeduct));
        setPayrollDeduct(billingSummary.payrollDeductDetails_ML);
        fillNextAutoPaymentText();
        fillPaidThroughText();
    };

    const setPayOnlineOrMail = () => {
        setPaymentMethodText(translator(messages.payOnlineOrByMail));
        fillPaymentDueText();
        fillPaymentScheduleText(); 
        fillPaidThroughText();
        setIsPayInFull(billingSummary.paymentSchedule_ML === 'Pay In Full (100% down)');
    };

    const setMortgagee = () => {
        setIsMortgagee(true);
        setPaymentMethodText(translator(messages.mortgageeBill));
        fillPaymentDueText();
    };

    const setPaymentDetails = () => {
        fillLastPaymentReceivedText();
        switch (billingSummary.policyPaymentMethod_ML) {
            case 'responsive':
                if (billingSummary.mortgageCompanyPaid_ML) {
                    setMortgagee();
                } else {
                    setIsResponsive(true);
                    setPayOnlineOrMail();
                }
                break;
            case 'creditcard':
                if (billingSummary.mortgageCompanyPaid_ML) {
                    setMortgagee();
                } else {
                    setIsCreditCard(true);
                    setCreditCardDetails();
                }
                break;
            case 'ach':
                if (billingSummary.mortgageCompanyPaid_ML) {
                    setMortgagee();
                } else {
                    setIsChecking(true);
                    setCheckingDetails();
                }
                break;
            case 'payrolldeduct_ml':
                setIsPayrollDeduct(true);
                setPayrollDeductFields();
                break;
            default:
                // setBillingInValid(true);
                break;
        }
    };

    useEffect(() => {
        setPaymentDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const openScheduleModal = useCallback(() => {
        const componentProps = {
            title: translator(mlPaymentSchedulePopupMsgs.paymentSchedule),
            overrideProps: {
                invoices: billingSummary.unpaidInvoices,
                convertLocalDateToDate,
                formatAmountString
            },
            CustomComponent: MLPolicyBillingPaymentSchedulePopup,
            showFooterOnCustomComponent: false,
            additionalPEStyle: 'customFooterModal',
            cancelBtnLabel: translator(mlPaymentSchedulePopupMsgs.close)
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    }, []);

    const redirectToBillingPolicySummary = useCallback(() => {
        if (fixedBCJobURL) {            
            window.open(`${fixedBCJobURL}/bc/PolicyPeriodEntry.do?policyNumber=${policyNumber}&termNumber=${termNumber}`);
        }
    }, [fixedBCJobURL, policyNumber, termNumber]);

    const makePayment = useCallback(() => {
        history.push(`/accounts/${accountNumber}/billing`);
    }, [history, accountNumber]);

    const getPayrollDeductDetailForField = useCallback((field) => {
        if (_.isUndefined(billingSummary.payrollDeductDetails_ML)) return '';
        return billingSummary.payrollDeductDetails_ML[field]
    }, [billingSummary.payrollDeductDetails_ML]);

    const getRoutingNumberText = useCallback(() => {
        if (billingSummary.routingNumber_ML && billingSummary.customerBankName_ML) return `(${billingSummary.routingNumber_ML}) (${billingSummary.customerBankName_ML})`;
        if (billingSummary.routingNumber_ML) return billingSummary.routingNumber_ML;
        if (billingSummary.customerBankName_ML) return billingSummary.customerBankName_ML;
        return '';
    }, [billingSummary.routingNumber_ML, billingSummary.customerBankName_ML]);

    const overrideProps = {
        viewInBCContainer: {
            visible: isGscUser && !!fixedBCJobURL
        },
        paymentMethodText: {
            content: paymentMethodText
        },
        expirationDateRow: {
            visible: isCreditCard
        },
        expirationDateText: {
            content: getFormattedDate(billingSummary.paymentExpirationDate_ML, 'MM/yyyy')
        },
        accountTypeRow: {
            visible: isChecking
        },
        accountTypeText: {
            content: billingSummary.accountType_ML
        },
        routingNumberRow: {
            visible: isChecking
        },
        routingNumberText: {
            content: getRoutingNumberText()
        },
        accountNumberRow: {
            visible: isChecking
        },
        accountNumberText: {
            content: accountNumberText
        },
        paymentScheduleRow: {
            visible: !isPayrollDeduct && !isMortgagee && !isPayInFull
        },
        paymentScheduleText: {
            content: (
                <>
                    {paymentScheduleText}&nbsp;<Link onClick={openScheduleModal}>{translator(messages.viewSchedule)}</Link>
                </>
            )
        },
        GPCCodeRow: {
            visible: isPayrollDeduct
        },
        GPCCodeText: {
            content: getPayrollDeductDetailForField('gpccode')
        },
        companyNameRow: {
            visible: isPayrollDeduct
        },
        companyNameText: {
            content: getPayrollDeductDetailForField('companyName')
        },
        payPointRow: {
            visible: isPayrollDeduct
        },
        payPointText: {
            content: getPayrollDeductDetailForField('payPoint')
        },
        IDNumberRow: {
            visible: isPayrollDeduct && !_.isUndefined(payrollDeduct.alternateID)
        },
        IDNumberText: {
            content: getPayrollDeductDetailForField('alternateID')
        },
        employeeNumberRow: {
            visible: isPayrollDeduct && !_.isUndefined(payrollDeduct.alternateID)
        },
        employeeNumberText: {
            content: getPayrollDeductDetailForField('employeeNumber')
        },
        departmentNumberRow: {
            visible: isPayrollDeduct && !_.isUndefined(payrollDeduct.alternateID)
        },
        departmentNumberText: {
            content: getPayrollDeductDetailForField('departmentNumber')
        },
        metroBadgeRow: {
            visible: isPayrollDeduct && !_.isUndefined(payrollDeduct.alternateID)
        },
        metroBadgeText: {
            content: getPayrollDeductDetailForField('metroBadge')
        },
        socialSecurityNumberRow: {
            visible: isPayrollDeduct
        },
        socialSecurityNumberText: {
            content: getPayrollDeductDetailForField('ssnmasked')
        },
        employeeNameRow: {
            visible: isPayrollDeduct
        },
        employeeNameText: {
            content: getPayrollDeductDetailForField('employeeName')
        },
        authorizationDateRow: {
            visible: !isResponsive && !isMortgagee
        },
        authorizationDateText: {
            content: getFormattedDate(billingSummary.authorizationDate_ML)
        },
        lastPaymentReceivedText: {
            content: lastPaymentReceivedText
        },
        paidThroughDateRow: {
            visible: !isMortgagee
        },
        paidThroughDateText: {
            content: paidThroughText
        },
        makePaymentBtn: {
            mlTagManagerLinkClick: "Policy Summary_Billing_Make a Payment"
        },
        nextAutoPaymentRow: {
            visible: !isResponsive && !isMortgagee
        },
        nextAutoPaymentText: {
            content: nextAutoPaymentText
        },
        nameOfMortgageRow: {
            visible: isMortgagee
        },
        nameOfMortgageText: {
            content: billingSummary.mortgageeName_ML
        },
        paymentDueRow: {
            visible: isResponsive || isMortgagee
        },
        paymentDueText: {
            content: paymentDueText
        },
        totalRemainingBalanceRow: {
            visible: isPayrollDeduct
        },
        totalRemainingBalanceText: {
            content: getFormattedAmount(payrollDeduct.remainingBalance)
        },
        remainingDeductionsRow: {
            visible: isPayrollDeduct
        },
        remainingDeductionsText: {
            content: payrollDeduct.remainingDeductions
        },
        totalDeductionsRow: {
            visible: isPayrollDeduct
        },
        totalDeductionsText: {
            content: payrollDeduct.totalDeductions
        },
        nextBillDateRow: {
            visible: isPayrollDeduct && !_.isEmpty(payrollDeduct?.nextBillDate_ML)
        },
        nextBillDateText: {
            content: getFormattedDate(payrollDeduct.nextBillDate_ML)
        },      
        payrollDateRow: {
            visible: isPayrollDeduct && !_.isEmpty(payrollDeduct?.payrollDate_ML)
        },
        payrollDateText: {
            content: getFormattedDate(payrollDeduct.payrollDate_ML)
        },  
        remittanceDelayRow: {
            visible: isPayrollDeduct
        },
        remittanceDelayText: {
            content: payrollDeduct.remittanceDelay === true ? translator(messages.yes) : (payrollDeduct.remittanceDelay === false ? translator(messages.no) : '')
        },
        updatePaymentComponentContainer: {
            visible: !canceled && !hasLimitedAccess
        },
        updatePaymentComponent: {
            policyNumber,
            productCode,
            singleStep: '/billing-details',
            label: translator(messages.updatePaymentOptions),
            history,
            buttonClassName: 'ml-btn-default'
        }        
    }

    const resolvers = {
        resolveCallbackMap: {
            redirectToBillingPolicySummary,
            makePayment
        },
        resolveComponentMap: {
            MLPolicyChangeBtnComponent            
        },
        resolveClassNameMap: styles
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers} />
    );
};

MLAgentPolicyBillingPaymentDetailsComponent.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func
    }),
    authUserData: PropTypes.shape({
        userType: PropTypes.string
    }),
    policyNumber: PropTypes.string,
    accountNumber: PropTypes.string,
    productCode: PropTypes.string,
    billingSummary: PropTypes.shape({}),
    termNumber: PropTypes.number,
    canceled: PropTypes.bool,
    hasLimitedAccess: PropTypes.bool,
    billingInValid: PropTypes.bool,
    setBillingInValid: PropTypes.func,
    convertLocalDateToDate: PropTypes.func,
    formatAmountString: PropTypes.func
};

MLAgentPolicyBillingPaymentDetailsComponent.defaultProps = {
    billingInValid: false
};

export default withRouter(withAuthenticationContext(MLAgentPolicyBillingPaymentDetailsComponent));